var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"transition":"dialog-bottom-transition","width":"700px"}},[_c('update-password-modal',{attrs:{"alert-text":_vm.alertMeta.text,"alert-type":_vm.alertMeta.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }